
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","height":"12","width":"7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#6e88f3","d":"M4.887.438a1.001 1.001 0 011.506 1.32l-3.749 4.28 3.749 4.28a1.001 1.001 0 01-1.506 1.32L.55 6.698a1 1 0 010-1.32z"}})])
          )
        }
      }
    